import { Clapperboard } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const MediaPage = lazyPage(() => import("./MediaPage"), "MediaPage");

export default defineModuleUi({
  key: "media",
  title: "Mídia",
  domain: "content",
  icon: Clapperboard,
  menu: [
    { path: "/conteudo/midia", label: "Mídia", minRole: "member", icon: Clapperboard, order: 55, keywords: "entrevista podcast palestra gravada imprensa youtube vídeo live" },
  ],
  routes: [{ path: "/conteudo/midia", element: <MediaPage />, minRole: "member" }],
  widgets: [],
});
